import {
  AccountBalance,
  Add,
  Apartment,
  ArrowBack,
  AttachMoney,
  CreditCardOutlined,
  Description,
  DirectionsCar,
  Domain,
  DriveEta,
  GridOn,
  Group,
  Home,
  LabelImportantOutlined,
  List,
  LocalParking,
  Map,
  Money,
  NetworkCellOutlined,
  NetworkCheck,
  Place,
  Policy,
  PrivacyTip,
  Public,
  Stars,
  Wallet,
  // Category,
  Groups,
  AssignmentInd,
} from "@mui/icons-material";
import {
  AccessibilityOutline,
  Build,
  BuildOutline,
  CashOutline,
  KeyOutline,
  LayersOutline,
  LogOutOutline,
  NavigateOutline,
  PeopleOutline,
  PersonOutline,
  SettingsOutline,
  ShieldCheckmarkOutline,
} from "@raresail/react-ionicons";
import { useGlobalContext } from "../context/GlobalContext";
import {
  // CAN_CONFIGURE_ASSET_SYSTEM,
  CAN_MANAGE_ENFORCEMENT_TEAMS,
  CAN_VIEW_ENFORCEMENT_TEAM_DETAILS,
} from "../utils/constants";
import {
  useCanViewDeployments,
  useDeploymentPermissions,
} from "../hooks/deployments/deploymentUtils";
import { getForm, getRegister } from "../utils/helpers";
// import { useGetUserPermissions } from "../utils/helpers";
import {
  IsAccountant,
  IsAdmin,
  IsHeadOfAccountant,
  // IsManager,
  IsPublicUser,
  IsSuperUser,
} from "../utils/permissions";
import {
  URL_AUDIT_ACTIVITY,
  URL_BOOKING_RESERVATION_RATES,
  URL_BOOKING_TYPE_CONFIGURABLE,
  URL_CAR_SLOT_MAPPING,
  URL_CONFIGURABLES,
  URL_COUNTIES,
  URL_DISTRICTS,
  URL_MASTER_DATA,
  URL_PARISHES,
  URL_PARKING_RATES,
  URL_PARKINGS,
  URL_PASSWORD_RESET,
  URL_PAYMENT_MODES,
  // URL_PAY_WEEK_CONFIGURATION,
  URL_PENALTY_SETTINGS,
  URL_ROLES,
  URL_SERVICE_RATES,
  URL_SERVICE_TYPES,
  URL_SETTINGS,
  URL_SLOTS,
  URL_STREETS,
  URL_SUB_COUNTIES,
  // URL_FIXED_WAGES,
  URL_SURCHARGE_CONFIGURABLES,
  URL_SYSTEM_ACCOUNTS,
  URL_TELECOM_NETWORK_CODES,
  URL_USERS,
  URL_USSD_STICKERS,
  URL_VEHICLE_TYPES,
  URL_VILLAGES,
  // URL_WAGES_BONUS,
  // URL_WAGES_CONFIGURATIONS,
  // URL_ASSET_CATEGORIES,
  URL_DEPLOYMENTS,
  URL_ENFORCEMENT_TEAMS,
} from "../utils/urls";

export const accountSettings = [
  {
    label: "Profile",
    icon: PersonOutline,
    to: URL_SETTINGS,
  },
  {
    label: "Change Password",
    icon: KeyOutline,
    to: getForm(URL_PASSWORD_RESET),
  },
  {
    label: "Logout",
    icon: LogOutOutline,
    to: "/logout",
  },
];

export const useSettings = () => {
  const isSupperAdmin = IsSuperUser();
  const isAdmin = IsAdmin();
  const isAccountant = IsAccountant();
  const isHeadOfAccountant = IsHeadOfAccountant();
  // const isManager = IsManager();
  // const canConfigureAssets = useGetUserPermissions().includes(
  // CAN_CONFIGURE_ASSET_SYSTEM,
  // );
  const canDeployment = useDeploymentPermissions();
  const canViewDeployments = useCanViewDeployments();
  const { updateData } = useGlobalContext();

  return [
    {
      label: "Back To Dashboard",
      icon: <ArrowBack />,
      to: "/",
      click: () => {
        updateData({ showSettings: false });
      },
    },

    {
      label: "Account Settings",
      key: "default",
      icon: <SettingsOutline />,
      to: URL_SETTINGS,
      visible: isSupperAdmin || isAdmin || isHeadOfAccountant,
    },

    // User Management
    {
      label: "User Management",
      icon: <PeopleOutline />,
      to: getRegister(URL_USERS),
      visible: isSupperAdmin || isAdmin,
      children: [
        {
          label: "Add User",
          icon: <Add />,
          to: getForm(URL_USERS),
          visible: !IsPublicUser(),
        },
        {
          label: "Users",
          icon: <Group />,
          to: getRegister(URL_USERS),
        },
        // users are deployed from the Deploy action on the users register
        {
          label: "Deployment Register",
          icon: <AssignmentInd />,
          to: getRegister(URL_DEPLOYMENTS),
          visible: canViewDeployments,
        },
      ],
    },

    // ROLES
    {
      label: "System Roles",
      icon: <AccessibilityOutline />,
      visible: isSupperAdmin,
      children: [
        {
          label: "New Role",
          icon: <Add />,
          to: getForm(URL_ROLES),
          visible: isSupperAdmin,
        },
        {
          label: "Roles Register",
          icon: <List />,
          to: getRegister(URL_ROLES),
          visible: isSupperAdmin,
        },
      ],
    },

    // Configurables
    {
      label: "Configurables",
      icon: <BuildOutline />,
      visible: isSupperAdmin || isAdmin,
      children: [
        // System Configurables
        {
          label: "System Configurables",
          icon: <Build />,
          visible: isSupperAdmin,
          children: [
            {
              label: "Create Configurable",
              icon: <Add />,
              to: getForm(URL_CONFIGURABLES),
              visible: isSupperAdmin,
            },
            {
              label: "All Configurables",
              icon: <Description />,
              to: getRegister(URL_CONFIGURABLES),
              visible: isSupperAdmin,
            },
          ],
        },
        {
          label: "USSD Stickers",
          icon: <Wallet />,
          visible: isSupperAdmin || isAdmin || isAccountant,
          children: [
            {
              label: "New USSD Stickers",
              icon: <Add />,
              to: `${URL_USSD_STICKERS}/create`,
            },
            {
              label: "USSD Stickers",
              icon: <Wallet />,
              to: getRegister(URL_USSD_STICKERS),
            },
          ],
        },

        // // Asset Configurables
        // {
        // label: "Asset Categories",
        // icon: <Category />,
        // visible: canConfigureAssets,
        // children: [
        // {
        // label: "New Asset Category",
        // icon: <Add />,
        // to: getForm(URL_ASSET_CATEGORIES),
        // },
        // {
        // label: "Asset Categories",
        // icon: <Category />,
        // to: getRegister(URL_ASSET_CATEGORIES),
        // },
        // ],
        // },

        // Parking Configurable
        {
          label: "Parking Configurables",
          icon: <LocalParking />,
          visible: isSupperAdmin || isAdmin,
          children: [
            {
              label: "Street",
              icon: <Map />,
              to: getRegister(URL_STREETS),
              visible: isSupperAdmin || isAdmin,
            },

            {
              label: "Parking Yard",
              icon: <LocalParking />,
              to: getRegister(URL_PARKINGS),
              visible: isSupperAdmin || isAdmin,
            },

            {
              label: "Parking Slots",
              icon: <GridOn />,
              to: getRegister(URL_SLOTS),
              visible: isSupperAdmin || isAdmin,
            },

            {
              label: "Parking Rates",
              icon: <AttachMoney />,
              to: getRegister(URL_PARKING_RATES),
              visible: isSupperAdmin,
            },

            {
              label: "Vehicle Types",
              icon: <DirectionsCar />,
              to: getRegister(URL_VEHICLE_TYPES),
              visible: isSupperAdmin || isAdmin,
            },

            {
              label: "Enforcement Teams",
              icon: <Groups />,
              visible: canDeployment(CAN_VIEW_ENFORCEMENT_TEAM_DETAILS),
              children: [
                {
                  label: "New Team",
                  icon: <Add />,
                  to: getForm(URL_ENFORCEMENT_TEAMS),
                  visible: canDeployment(CAN_MANAGE_ENFORCEMENT_TEAMS),
                },
                {
                  label: "Enforcement Teams",
                  icon: <Groups />,
                  to: getRegister(URL_ENFORCEMENT_TEAMS),
                },
              ],
            },

            {
              label: "Car Slot Mapping",
              icon: <DriveEta />,
              to: getRegister(URL_CAR_SLOT_MAPPING),
              visible: isSupperAdmin,
            },
          ],
        },

        // Telecom Configurables
        {
          label: "Telecom Configurables",
          icon: <NetworkCellOutlined />,
          visible: isSupperAdmin,
          children: [
            {
              label: "Telecom Code",
              icon: <NetworkCheck />,
              to: getRegister(URL_TELECOM_NETWORK_CODES),
            },
          ],
        },

        // SURCHARGES
        {
          label: "Surcharges Configurables",
          icon: <Money />,
          to: getRegister(URL_SURCHARGE_CONFIGURABLES),
          visible: isSupperAdmin,
        },
        // PENALTY SETTINGS
        {
          label: "Penalties",
          icon: <CashOutline />,
          visible: isSupperAdmin,
          children: [
            {
              label: "New Setting",
              icon: <Add />,
              to: getForm(URL_PENALTY_SETTINGS),
            },
            {
              label: "Penalty Settings",
              icon: <Policy />,
              to: getRegister(URL_PENALTY_SETTINGS),
            },
          ],
        },

        // BOOKING
        {
          label: "Bookings / Reservations",
          icon: <LabelImportantOutlined />,
          visible: isSupperAdmin,
          children: [
            {
              label: "Booking Types",
              icon: <LabelImportantOutlined />,
              to: getRegister(URL_BOOKING_TYPE_CONFIGURABLE),
            },

            {
              label: "Booking Rates",
              icon: <CreditCardOutlined />,
              to: getRegister(URL_BOOKING_RESERVATION_RATES),
            },
          ],
        },
        // PAYMENT MODES
        {
          label: "Payment Modes",
          icon: <CreditCardOutlined />,
          to: getRegister(URL_PAYMENT_MODES),
          visible: isSupperAdmin,
        },

        // // WAGES
        // {
        // label: "Wages Configurations",
        // icon: <Wallet />,
        // visible:
        // isSupperAdmin ||
        // isAdmin ||
        // isAccountant ||
        // isHeadOfAccountant ||
        // isManager,
        // children: [
        // {
        // label: "Wages",
        // icon: <Wallet />,
        // children: [
        // {
        // label: "New Configuration",
        // icon: <Add />,
        // to: getForm(URL_WAGES_CONFIGURATIONS),
        // },

        // {
        // label: "Wages Configurations",
        // icon: <CreditCardOutlined />,
        // to: getRegister(URL_WAGES_CONFIGURATIONS),
        // },
        // ],
        // },
        // {
        // label: "Wages Bonus",
        // icon: <Wallet />,
        // children: [
        // {
        // label: "New Bonus",
        // icon: <Add />,
        // to: getForm(URL_WAGES_BONUS),
        // },

        // {
        // label: "Wages Bonus",
        // icon: <CreditCardOutlined />,
        // to: getRegister(URL_WAGES_BONUS),
        // },
        // ],
        // },
        // {
        // label: "Fixed Wages Config",
        // icon: <Wallet />,
        // children: [
        // {
        // label: "New Configuration",
        // icon: <Add />,
        // to: getForm(URL_FIXED_WAGES),
        // },

        // {
        // label: "Fixed Wages",
        // icon: <CreditCardOutlined />,
        // to: getRegister(URL_FIXED_WAGES),
        // },
        // ],
        // },
        // {
        // label: "Pay Week",
        // icon: <Wallet />,
        // children: [
        // {
        // label: "New Pay Week",
        // icon: <Add />,
        // to: getForm(URL_PAY_WEEK_CONFIGURATION),
        // },

        // {
        // label: "Pay Week",
        // icon: <CreditCardOutlined />,
        // to: getRegister(URL_PAY_WEEK_CONFIGURATION),
        // },
        // ],
        // },
        // ],
        // },
      ],
    },

    //   Master Data
    {
      label: "Master Data",
      icon: <NavigateOutline />,
      visible: isSupperAdmin || isAdmin,
      children: [
        {
          label: "Add Master Data",
          icon: <Add />,
          visible: isSupperAdmin || isAdmin,
          to: getForm(URL_MASTER_DATA),
        },
        {
          label: "Districts",
          icon: <Public />,
          to: getRegister(URL_DISTRICTS),
        },
        {
          label: "Counties",
          icon: <Place />,
          to: getRegister(URL_COUNTIES),
        },
        {
          label: "SubCounties",
          icon: <Apartment />,
          to: getRegister(URL_SUB_COUNTIES),
        },
        {
          label: "Parishes",
          icon: <Domain />,
          to: getRegister(URL_PARISHES),
        },
        {
          label: "Villages",
          icon: <Home />,
          to: getRegister(URL_VILLAGES),
        },
      ],
    },

    // SERVICES
    {
      label: "Services",
      icon: <LayersOutline />,
      visible: isSupperAdmin || isAdmin,
      children: [
        {
          label: "Service Rates",
          icon: <Stars />,
          to: getRegister(URL_SERVICE_RATES),
        },
        {
          label: "Service Types",
          icon: <PrivacyTip />,
          to: getRegister(URL_SERVICE_TYPES),
        },
      ],
    },

    {
      label: "System Accounts",
      icon: <AccountBalance />,
      to: getRegister(URL_SYSTEM_ACCOUNTS),
      visible: isSupperAdmin || isAdmin || isAccountant || isHeadOfAccountant,
    },

    // AUDIT_ACTIVITY
    {
      label: "Audit Activity",
      icon: <ShieldCheckmarkOutline />,
      to: getRegister(URL_AUDIT_ACTIVITY),
      visible: isSupperAdmin,
    },
  ];
};
